<!-- ═══════════════════════════════════════════════════════════════════════════
     FikoCAD Farklar - CATIA V5 Compare Products Tarzı
     ═══════════════════════════════════════════════════════════════════════════ -->

<div class="govde">

    <!-- Header -->
    <div class="baslik">
        <i class="exchange alternate icon"></i>
        CAD Farklar
        <span class="alt-bilgi" *ngIf="sonuc">
            | {{ sonuc.sure.toFixed(0) }}ms
            <span class="tier-badge" [class.gpu]="sonuc.tier === 'gpu'">{{ sonuc.tier.toUpperCase() }}</span>
        </span>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         DEFINITION - Model Seçimi
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel">
        <div class="section-title">Model Tanımı</div>

        <div class="secim-panel">
            <!-- Model A (Eski Versiyon) -->
            <div class="model-kutu model-a" [class.secili]="modelA" [class.secim-modu]="secimModu === 'A'">
                <div class="model-baslik">
                    <span class="etiket">A</span>
                    <span>Eski versiyon:</span>
                </div>

                <div class="model-icerik" *ngIf="modelA; else modelABos">
                    <i class="cube icon"></i>
                    <span class="model-isim" [title]="modelA.isim">{{ modelA.isim }}</span>
                    <button class="ui icon mini button temizle-btn" title="Temizle" (click)="modelA = null; CD.detectChanges();">
                        <i class="times icon"></i>
                    </button>
                </div>

                <ng-template #modelABos>
                    <div class="model-icerik bos">
                        <div class="butonlar">
                            <button class="ui icon mini button" title="Listeden seç"
                                [class.active]="dropdownAcikA"
                                [disabled]="mevcutModeller.length === 0"
                                (click)="dropdownAToggle(); $event.stopPropagation()">
                                <i class="list icon"></i>
                            </button>
                            <button class="ui icon mini button" title="Sahneden seç"
                                [class.active]="secimModu === 'A'"
                                (click)="sahnedenSec('A')">
                                <i class="crosshairs icon"></i>
                            </button>
                        </div>
                    </div>
                </ng-template>

                <div class="model-dropdown acik" *ngIf="dropdownAcikA && mevcutModeller.length > 0">
                    <div class="dropdown-item" *ngFor="let m of mevcutModeller" (click)="modelASecildi(m)">
                        <i class="cube icon"></i> {{ m.isim }}
                    </div>
                </div>
            </div>

            <!-- Değiştir -->
            <button class="ui icon mini button swap-btn" title="Değiştir" (click)="modelleriDegistir()">
                <i class="exchange icon"></i>
            </button>

            <!-- Model B (Yeni Versiyon) -->
            <div class="model-kutu model-b" [class.secili]="modelB" [class.secim-modu]="secimModu === 'B'">
                <div class="model-baslik">
                    <span class="etiket">B</span>
                    <span>Yeni versiyon:</span>
                </div>

                <div class="model-icerik" *ngIf="modelB; else modelBBos">
                    <i class="cube icon"></i>
                    <span class="model-isim" [title]="modelB.isim">{{ modelB.isim }}</span>
                    <button class="ui icon mini button temizle-btn" title="Temizle" (click)="modelB = null; CD.detectChanges();">
                        <i class="times icon"></i>
                    </button>
                </div>

                <ng-template #modelBBos>
                    <div class="model-icerik bos">
                        <div class="butonlar">
                            <button class="ui icon mini button" title="Listeden seç"
                                [class.active]="dropdownAcikB"
                                [disabled]="mevcutModeller.length === 0"
                                (click)="dropdownBToggle(); $event.stopPropagation()">
                                <i class="list icon"></i>
                            </button>
                            <button class="ui icon mini button" title="Sahneden seç"
                                [class.active]="secimModu === 'B'"
                                (click)="sahnedenSec('B')">
                                <i class="crosshairs icon"></i>
                            </button>
                        </div>
                    </div>
                </ng-template>

                <div class="model-dropdown acik" *ngIf="dropdownAcikB && mevcutModeller.length > 0">
                    <div class="dropdown-item" *ngFor="let m of mevcutModeller" (click)="modelBSecildi(m)">
                        <i class="cube icon"></i> {{ m.isim }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Seçim uyarısı -->
    <div class="secim-uyari" *ngIf="secimModu !== 'yok'">
        <i class="info circle icon"></i>
        Model {{ secimModu }}'yı sahne veya ağaçtan seçin
        <button class="ui icon mini button" (click)="secimIptal()">
            <i class="times icon"></i>
        </button>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         KARŞILAŞTIRMA MODU - Geometrik / Görsel
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel">
        <div class="mode-selector">
            <label class="radio-option">
                <input type="radio" name="compMode" value="geometric"
                       [checked]="comparisonMode === 'geometric'"
                       (change)="comparisonMode = 'geometric'; CD.detectChanges()">
                <span>Geometrik Karşılaştırma</span>
            </label>
            <label class="radio-option">
                <input type="radio" name="compMode" value="visual"
                       [checked]="comparisonMode === 'visual'"
                       (change)="comparisonMode = 'visual'; CD.detectChanges()">
                <span>Görsel Karşılaştırma</span>
            </label>
        </div>

        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="useLocalAxis">
            <span>Yerel eksen sistemini kullan</span>
        </label>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         GEOMETRİK KARŞILAŞTIRMA AYARLARI
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel" *ngIf="comparisonMode === 'geometric'">
        <div class="section-title">Geometrik Karşılaştırma</div>

        <div class="ayar-satir">
            <span class="ayar-label">Hesaplama hassasiyeti:</span>
            <input type="number" class="fikoinput"
                   [(ngModel)]="computationAccuracy"
                   step="0.1" min="0.01" max="100">
            <span class="birim">mm</span>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Görüntüleme hassasiyeti:</span>
            <input type="range" class="slider"
                   [(ngModel)]="displayAccuracy"
                   min="0.1" max="10" step="0.1">
            <span class="birim">{{ displayAccuracy.toFixed(1) }}mm</span>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Tür:</span>
            <select class="fikoinput select" [(ngModel)]="comparisonType">
                <option value="added_removed">Eklenen + Silinen</option>
                <option value="added_only">Sadece Eklenen</option>
                <option value="removed_only">Sadece Silinen</option>
            </select>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         GÖRSEL KARŞILAŞTIRMA AYARLARI
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel" *ngIf="comparisonMode === 'visual'">
        <div class="section-title">Görsel Karşılaştırma</div>

        <div class="ayar-satir">
            <span class="ayar-label">Karşılaştırma hassasiyeti:</span>
            <input type="range" class="slider"
                   [(ngModel)]="visualAccuracy"
                   min="0.1" max="5" step="0.1">
            <span class="birim">{{ visualAccuracy.toFixed(1) }}mm</span>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Tür:</span>
            <select class="fikoinput select" [(ngModel)]="comparisonType">
                <option value="added_removed">Eklenen + Silinen</option>
                <option value="added_only">Sadece Eklenen</option>
                <option value="removed_only">Sadece Silinen</option>
            </select>
        </div>

        <div class="view-mode-selector">
            <label class="radio-option">
                <input type="radio" name="viewMode" value="both"
                       [checked]="viewMode === 'both'"
                       (change)="viewMode = 'both'">
                <span>Her İkisi</span>
            </label>
            <label class="radio-option">
                <input type="radio" name="viewMode" value="old_only"
                       [checked]="viewMode === 'old_only'"
                       (change)="viewMode = 'old_only'">
                <span>Sadece Eski</span>
            </label>
            <label class="radio-option">
                <input type="radio" name="viewMode" value="new_only"
                       [checked]="viewMode === 'new_only'"
                       (change)="viewMode = 'new_only'">
                <span>Sadece Yeni</span>
            </label>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         RENK & KENAR AYARLARI
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel">
        <div class="section-title">Görüntüleme Ayarları</div>

        <!-- Kenar göster/gizle -->
        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="showEdges">
            <span>Kenarları Göster</span>
        </label>

        <!-- Gradient heatmap -->
        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="useHeatmapGradient">
            <span>Gradient Heatmap</span>
        </label>

        <!-- Sınır üçgen refinement -->
        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="refineBoundary">
            <span>Sınır Üçgen Refine</span>
        </label>

        <!-- Sadece farkları göster -->
        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="showOnlyDifferences">
            <span>Sadece Farkları Göster</span>
        </label>

        <!-- Overlay: modelleri üst üste bindirme -->
        <label class="checkbox-option">
            <input type="checkbox" [(ngModel)]="overlayMode">
            <span>Overlay (Üst Üste)</span>
        </label>

        <!-- Renk Seçiciler -->
        <div class="renk-ayarlari">
            <div class="renk-satir">
                <span class="renk-etiket">Aynı:</span>
                <input type="color" class="renk-picker"
                       [value]="rgbToHex(colors.same)"
                       (change)="onColorChange('same', $any($event.target).value)">
            </div>
            <div class="renk-satir">
                <span class="renk-etiket">Silinen:</span>
                <input type="color" class="renk-picker"
                       [value]="rgbToHex(colors.removed)"
                       (change)="onColorChange('removed', $any($event.target).value)">
            </div>
            <div class="renk-satir">
                <span class="renk-etiket">Eklenen:</span>
                <input type="color" class="renk-picker"
                       [value]="rgbToHex(colors.added)"
                       (change)="onColorChange('added', $any($event.target).value)">
            </div>
            <div class="renk-satir" *ngIf="showEdges">
                <span class="renk-etiket">Kenar:</span>
                <input type="color" class="renk-picker"
                       [value]="rgbToHex(edgeColor)"
                       (change)="onColorChange('edge', $any($event.target).value)">
            </div>
            <button class="ui mini button reset-btn" (click)="resetColors()" title="Varsayılana sıfırla">
                <i class="undo icon"></i>
            </button>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         GELİŞMİŞ AYARLAR - Fark Filtresi
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="section-panel gelismis-panel" *ngIf="showOnlyDifferences">
        <div class="section-title">
            Fark Filtre Ayarları
            <div class="preset-buttons">
                <button class="preset-btn" [class.active]="activePreset === 'hassas'" (click)="applyPreset('hassas')" title="Hassas: t×5, depth 4, ghost 20%">Hassas</button>
                <button class="preset-btn" [class.active]="activePreset === 'standart'" (click)="applyPreset('standart')" title="Standart: t×10, depth 3, ghost 20%">Standart</button>
                <button class="preset-btn" [class.active]="activePreset === 'hizli'" (click)="applyPreset('hizli')" title="Hızlı: t×20, depth 1, ghost 10%">Hızlı</button>
            </div>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Yüzey filtresi:</span>
            <input type="range" class="slider"
                   [(ngModel)]="surfaceFilterMultiplier"
                   min="1" max="30" step="1">
            <span class="birim">×{{ surfaceFilterMultiplier }}</span>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Sınır hassasiyeti:</span>
            <input type="range" class="slider"
                   [(ngModel)]="subdivisionDepth"
                   min="0" max="5" step="1">
            <span class="birim">{{ subdivisionDepth }}</span>
        </div>

        <div class="ayar-satir">
            <span class="ayar-label">Ghost opaklığı:</span>
            <input type="range" class="slider"
                   [(ngModel)]="ghostOpacity"
                   min="0" max="0.5" step="0.01">
            <span class="birim">{{ (ghostOpacity * 100).toFixed(0) }}%</span>
        </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         İLERLEME ÇUBUĞU (işlem sırasında)
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="progress-panel" *ngIf="islemYapiliyor">
        <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="progressYuzde"></div>
        </div>
        <div class="progress-text">{{ progressMesaj }}</div>
        <button class="ui icon mini button cancel-btn" title="İptal" (click)="iptalEt()">
            <i class="stop icon"></i>
        </button>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         KARŞILAŞTIR BUTONU
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="button-row">
        <button class="ui button preview-btn"
                [disabled]="!modelA || !modelB || islemYapiliyor"
                (click)="karsilastir()">
            <i class="sync alternate icon" [class.loading]="islemYapiliyor"></i>
            {{ islemYapiliyor ? 'Hesaplanıyor...' : 'Önizle' }}
        </button>
        <button class="ui button" (click)="temizle()">Kapat</button>
    </div>

    <!-- ═══════════════════════════════════════════════════════════════════════
         SONUÇLAR
         ═══════════════════════════════════════════════════════════════════════ -->

    <div class="sonuclar" *ngIf="sonuc">

        <!-- Eşleşme Oranı - Büyük Gösterge -->
        <div class="eslesme-gostergesi" [class.iyi]="sonuc.toleransIcindeYuzde >= 90"
             [class.orta]="sonuc.toleransIcindeYuzde >= 50 && sonuc.toleransIcindeYuzde < 90"
             [class.kotu]="sonuc.toleransIcindeYuzde < 50">
            <div class="eslesme-yuzde">{{ sonuc.toleransIcindeYuzde.toFixed(1) }}%</div>
            <div class="eslesme-etiket">Eşleşme</div>
        </div>

        <!-- Renk Açıklaması (binary mod) -->
        <div class="renk-aciklama" *ngIf="!useHeatmapGradient">
            <div class="renk-item">
                <span class="renk-kutu" [style.background-color]="rgbToHex(colors.same)"></span>
                <span>Aynı</span>
            </div>
            <div class="renk-item">
                <span class="renk-kutu" [style.background-color]="rgbToHex(colors.removed)"></span>
                <span>Silinen</span>
            </div>
            <div class="renk-item">
                <span class="renk-kutu" [style.background-color]="rgbToHex(colors.added)"></span>
                <span>Eklenen</span>
            </div>
        </div>

        <!-- Gradient Heatmap Legend -->
        <div class="gradient-legend" *ngIf="useHeatmapGradient">
            <div class="gradient-bar"
                 [style.background]="'linear-gradient(to right, ' + rgbToHex(colors.same) + ', #ff8c00, ' + rgbToHex(colors.removed) + ')'">
            </div>
            <div class="gradient-labels">
                <span>0</span>
                <span>{{ formatMesafe(sonuc.maxSapma) }}</span>
            </div>
        </div>

        <!-- İstatistikler -->
        <div class="catia-stats">
            <div class="stat-row">
                <span class="stat-label">Silinen (A):</span>
                <span class="stat-value kirmizi">{{ formatSayi(sonuc.farkliVertexA, 0) }}</span>
            </div>
            <div class="stat-row">
                <span class="stat-label">Eklenen (B):</span>
                <span class="stat-value mavi">{{ formatSayi(sonuc.farkliVertexB, 0) }}</span>
            </div>
            <div class="stat-row stat-separator" *ngIf="sonuc.maxSapma > 0">
                <span class="stat-label">Maks. sapma (P99):</span>
                <span class="stat-value">{{ formatMesafe(sonuc.maxSapma) }}</span>
            </div>
            <div class="stat-row" *ngIf="sonuc.ortalamaSapma > 0">
                <span class="stat-label">Ort. sapma:</span>
                <span class="stat-value">{{ formatMesafe(sonuc.ortalamaSapma) }}</span>
            </div>
            <div class="stat-row" *ngIf="sonuc.stdSapma > 0">
                <span class="stat-label">Std. sapma:</span>
                <span class="stat-value">{{ formatMesafe(sonuc.stdSapma) }}</span>
            </div>
        </div>

        <!-- Vertex Bilgisi -->
        <div class="vertex-bilgi">
            <span>A: {{ sonuc.vertexSayisiA | number }} v</span>
            <span>B: {{ sonuc.vertexSayisiB | number }} v</span>
        </div>

        <!-- Araç Çubuğu -->
        <div class="arac-cubugu">
            <button class="ui icon mini button"
                    [class.active]="!orijinallerGizli"
                    title="Orijinal Modelleri Göster"
                    (click)="orijinalToggle()">
                <i class="cube icon"></i>
            </button>
            <button class="ui icon mini button"
                    [class.active]="showEdges"
                    title="Kenarları Aç/Kapat"
                    (click)="toggleEdges()">
                <i class="border all icon"></i>
            </button>
            <button class="ui icon mini button"
                    title="Farklara Odaklan"
                    (click)="farkaOdaklan()">
                <i class="crosshairs icon"></i>
            </button>
            <button class="ui icon mini button"
                    title="Karşılaştırma Penceresi"
                    (click)="karsilastirmaPenceresiAc()">
                <i class="columns icon"></i>
            </button>
            <button class="ui icon mini button"
                    title="Sonuçları Dışa Aktar (JSON)"
                    (click)="sonuclariAktar()">
                <i class="download icon"></i>
            </button>
            <button class="ui icon mini button"
                    title="Sapma Raporu (CSV)"
                    (click)="raporAktar()">
                <i class="file alternate icon"></i>
            </button>
            <button class="ui icon mini button"
                    title="Temizle"
                    (click)="temizle()">
                <i class="trash icon"></i>
            </button>
        </div>

    </div>

    <!-- Alt butonlar (sonuç yokken) -->
    <div class="alt-butonlar" *ngIf="!sonuc && !islemYapiliyor">
        <button class="ui icon mini button" title="Listeyi Yenile" (click)="modelleriTara()">
            <i class="refresh icon"></i>
        </button>
    </div>

</div>
